import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api-client';

import { rolesQueryKey } from './queryKeys';
import { type ListRolesResponse } from '../models/role';

export const getRoles = async () => {
  const response = await api.get<ListRolesResponse>('/v1/roles');
  return response.data;
};

// ponytail: plain useQuery, not useAppQuery — the endpoint takes no game/sandbox
// scope, and the Access area mounts above :sandboxCode where SandboxProvider
// isn't available.
export const useRoles = () =>
  useQuery({
    queryKey: rolesQueryKey.all,
    queryFn: getRoles,
  });
